import appConfig from '@nerdwallet/app-config';

import { passwordValidations } from '../validations';

export default {
  initialState: {
    form: {},
  },
  redirectUrl: '',
  formConfig: [
    {
      viewType: 'input',
      title: 'Password',
      value: '{{0}}',
      formatType: 'none',
      subType: 'text',
      type: 'password',
      keys: [
        {
          key: 'form.totalRewardsPassword',
        },
      ],
      getValidationConfig({ form, attemptedSubmit }) {
        const isValid =
          !attemptedSubmit ||
          form.totalRewardsPassword === appConfig.TOTAL_REWARDS_PW;
        return {
          isValid,
          errors: passwordValidations.errors,
          feedback: isValid ? null : passwordValidations.feedback,
        };
      },
    },
  ],
  buttonText: 'My Rewards',
};
